import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { PUSH_FUNNEL, PUSH_STATS, PUSH_VOLUME } from '../data/pushStats';
import Skeleton from '../components/ui/Skeleton';
import ProgressBar from '../components/ui/ProgressBar';
import styles from './Push.module.css';

class Push extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() { setTimeout(() => this.setState({ loading: false }), 700); }

  render() {
    const { loading } = this.state;

    const volData = PUSH_VOLUME.labels.map((l, i) => ({
      l, android: PUSH_VOLUME.android[i], ios: PUSH_VOLUME.ios[i],
    }));

    return (
      <>
        <div className={styles.pageHead}>
          <div>
            <div className={styles.pageTitle}>Push Notifications</div>
            <div className={styles.pageSub}>Delivery · engagement · opt-in analytics</div>
          </div>
        </div>

        {/* KPI stats */}
        <div className={styles.statGrid}>
          {loading
            ? [0,1,2,3,4,5].map(i => (
                <div key={i} className={styles.statCard}>
                  <Skeleton variant="text" width={60} height={24} />
                  <Skeleton variant="text" width={120} height={12} style={{ marginTop: 6 }} />
                </div>
              ))
            : PUSH_STATS.map((s, i) => (
                <div key={i} className={styles.statCard}>
                  <div className={styles.statVal} style={{ color: s.col }}>{s.v}</div>
                  <div className={styles.statLabel}>{s.l}</div>
                  <div className={styles.statSub}>{s.b}</div>
                </div>
              ))
          }
        </div>

        <div className={styles.grid2}>
          {/* Volume chart */}
          <div className={styles.card}>
            <div className={styles.cardHead}>
              <div className={styles.cardTitle}>Push Volume by Platform</div>
              <div className={styles.cardSub}>Android vs iOS · last 7 days</div>
            </div>
            <div className={styles.cardBody}>
              <ResponsiveContainer width="100%" height={185}>
                <BarChart data={volData} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="var(--b1)" vertical={false} />
                  <XAxis dataKey="l" tick={{ fill: 'var(--t3)', fontSize: 10 }} axisLine={false} tickLine={false} />
                  <YAxis tick={{ fill: 'var(--t3)', fontSize: 10 }} axisLine={false} tickLine={false} />
                  <Tooltip contentStyle={{ background: 'var(--s3)', border: '1px solid var(--b2)', borderRadius: 8, fontSize: 12 }} />
                  <Legend wrapperStyle={{ fontSize: 11, color: 'var(--t3)' }} />
                  <Bar dataKey="android" name="Android" fill="#B94040" radius={[3, 3, 0, 0]} />
                  <Bar dataKey="ios" name="iOS" fill="#5080B8" radius={[3, 3, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Funnel */}
          <div className={styles.card}>
            <div className={styles.cardHead}>
              <div className={styles.cardTitle}>Delivery Funnel</div>
              <div className={styles.cardSub}>Sent → converted · last 30d</div>
            </div>
            <div className={styles.funnelWrap}>
              {PUSH_FUNNEL.map((step, i) => (
                <div key={i} className={styles.funnelRow}>
                  <div className={styles.funnelLbl}>{step.l}</div>
                  <div className={styles.funnelBarWrap}>
                    <ProgressBar value={step.p} max={100} size="sm" color={step.col} />
                  </div>
                  <div className={styles.funnelCnt} style={{ color: step.col }}>{step.c}</div>
                  <div className={styles.funnelPct}>{step.p}%</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Push;
